'use strict';

require('babel-polyfill');
require('whatwg-fetch');



//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 399
// module chunks = 0